import { Login } from '.'

export const enSG: Login = {
  LoginPage: {
    slogan: 'Build secure government forms in minutes',
  },
  components: {
    LoginForm: {
      onlyAvailableForPublicOfficers:
        'Log in with a .gov.sg or other whitelisted email address',
      emailEmptyErrorMsg: 'Please enter an email address',
      login: 'Log in',
      haveAQuestion: 'Have a question?',
    },
  },
}
